import { useVideoContext } from './use-video-context';
import { useDominantSpeaker } from './use-dominant-speaker';
import { useParticipants } from './use-participants';
// import useSelectedParticipant from '../../components/VideoProvider/useSelectedParticipant/useSelectedParticipant';

export const useMainParticipant = () => {
  // const [selectedParticipant] = useSelectedParticipant();
  const dominantSpeaker = useDominantSpeaker();
  const participants = useParticipants();
  const { room } = useVideoContext();
  const localParticipant = room?.localParticipant;

  // The participant that is returned is displayed in the main video area. Changing the order of the following
  // variables will change the how the main speaker is determined.
  return dominantSpeaker || participants[0] || localParticipant;
};
